export class MarkMessageUnreadRequest {
  private Action = 'MarkMessageUnread';
  public PublicToken: string;
  public MessageId: number;

  constructor({ PublicToken, MessageId }) {
    this.PublicToken = PublicToken;
    this.MessageId = MessageId;
  }
}
